import { FC } from "react";
import "./styles.scss";
import { PageShell } from "../PageShell";
import { useTranslation } from "../../../hooks/useTranslation";
import { TEAM_MEMBERS } from "./teamMembers";
import { TeamMemberCard } from "./TeamMemberCard";
import teamBanner from "../../../assets/images/landing/banners/team-banner.jpeg";

interface TeamMemberContent {
  name: string;
  role: string;
  bio: string;
}

export const TeamPage: FC = () => {
  const { p } = useTranslation("landing_team");

  // i18next's TS types don't model `returnObjects` for this project's
  // untyped (plain-JS-loaded) translation bundles, so the object shape
  // returned here is asserted. The actual content is authored in
  // public/locales/*/translation.json under landing_team.members.<id>,
  // one entry per id in teamMembers.ts.
  const members = p("members", { returnObjects: true }) as unknown as Record<
    string,
    TeamMemberContent
  >;

  return (
    <PageShell>
      <div className="landing-team-page">
        <img src={teamBanner} alt="" className="landing-team-page__banner" />
        <div className="landing-team-page__head">
          <h1 className="landing-team-page__heading">{p("heading")}</h1>
          {/* New look only (site.module.scss): the thin route line of the calm header (board 358). */}
          <svg className="landing-team-page__route" viewBox="0 0 320 56" preserveAspectRatio="none" aria-hidden="true" focusable="false">
            <path d="M0 40 C 70 52, 120 20, 190 30 S 280 24, 320 10" fill="none" strokeWidth="2" strokeLinecap="round" style={{ stroke: "var(--cy-primary)" }} />
            {[[150, 28], [316, 10]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="4" strokeWidth="2" style={{ fill: "var(--cy-surface)", stroke: "var(--cy-primary)" }} />)}
          </svg>
        </div>
        <p className="landing-team-page__intro">{p("intro")}</p>

        <div className="landing-team-page__grid">
          {TEAM_MEMBERS.map((member) => {
            const content = members?.[member.id];
            if (!content) return null;
            return (
              <TeamMemberCard
                key={member.id}
                photo={member.photo}
                name={content.name}
                role={content.role}
                bio={content.bio}
              />
            );
          })}
        </div>

        <p className="landing-team-page__closing">{p("closing")}</p>
      </div>
    </PageShell>
  );
};
